// Lightweight UI translations. Questions + academic content remain in English by design.
// Archie (AI tutor) responses are translated server-side via preferred_language.

export const translations = {
  en: {
    // Navigation
    nav_home: "Home",
    nav_learn: "Learn",
    nav_lessons: "Lessons",
    nav_tutor: "AI Tutor",
    nav_ranks: "Ranks",
    nav_premium: "Premium",
    nav_profile: "Profile",
    nav_tutorials: "Tutorials",
    nav_about: "About",
    nav_logout: "Log Out",

    // Dashboard
    dashboard_welcome: "Welcome back",
    dashboard_tagline: "Ready to crush some practice questions today?",
    readiness_title: "Test Readiness Score",
    readiness_ready: "Ready",
    readiness_almost: "Almost Ready",
    readiness_not: "Not Ready",
    readiness_weak_topics: "Topics to review",
    readiness_no_data: "Answer a few questions to see your score.",
    recommended_for_you: "Archie recommends",
    start_lesson: "Start Lesson",

    // Lessons
    lessons_title: "Interactive Lessons",
    lessons_subtitle: "Khan-style AI lessons tailored to your test",
    lessons_remaining: "lessons remaining",
    lessons_unlimited: "Unlimited lessons",
    lessons_free_limit: "Free plan: 3 total lessons",
    lessons_upgrade: "Upgrade for unlimited lessons",
    lesson_summary: "Key Takeaways",
    lesson_practice: "Practice",
    lesson_continue: "Continue to Practice",
    lesson_complete: "Complete Lesson",
    lesson_new: "Start a New Lesson",
    pick_topic: "Pick a topic",

    // Onboarding
    onboarding_welcome: "Welcome to ClearPath!",
    onboarding_step1: "1. Pick your test",
    onboarding_step1_body: "Choose from STAAR, SAT, ACT, ASVAB, TSI, or Citizenship.",
    onboarding_step2: "2. Answer practice questions",
    onboarding_step2_body: "Earn XP for every correct answer and build your streak.",
    onboarding_step3: "3. Read the explanations",
    onboarding_step3_body: "Every answer comes with a clear explanation.",
    onboarding_step4: "4. Chat with Archie",
    onboarding_step4_body: "Your AI tutor — ask anything, any time.",
    onboarding_step5: "5. Track your readiness",
    onboarding_step5_body: "Watch your dashboard readiness score rise as you practice.",
    onboarding_skip: "Skip",
    onboarding_next: "Next",
    onboarding_finish: "Let's go!",

    // Settings
    settings_title: "Settings",
    settings_accessibility: "Accessibility",
    settings_dyslexia: "Dyslexia-Friendly Mode",
    settings_dyslexia_desc: "Larger text, cream background, chunked paragraphs, and text-to-speech.",
    settings_language: "Language",
    settings_language_desc: "Translate the app interface. Practice questions stay in English.",
    settings_replay_tour: "Replay the welcome tour",

    // Paywall
    paywall_title: "Don't stop now!",
    paywall_message: "You've used all 10 free questions today. Your STAAR test is coming — don't stop now. Upgrade to Premium for unlimited practice.",
    upgrade_button: "Upgrade to Premium",
  },
  es: {
    nav_home: "Inicio",
    nav_learn: "Aprender",
    nav_lessons: "Lecciones",
    nav_tutor: "Tutor IA",
    nav_ranks: "Ranking",
    nav_premium: "Premium",
    nav_profile: "Perfil",
    nav_tutorials: "Tutoriales",
    nav_about: "Acerca de",
    nav_logout: "Cerrar sesión",

    dashboard_welcome: "Bienvenido de nuevo",
    dashboard_tagline: "¿Listo para practicar hoy?",
    readiness_title: "Puntuación de Preparación",
    readiness_ready: "Listo",
    readiness_almost: "Casi Listo",
    readiness_not: "No Listo",
    readiness_weak_topics: "Temas por repasar",
    readiness_no_data: "Responde algunas preguntas para ver tu puntuación.",
    recommended_for_you: "Archie recomienda",
    start_lesson: "Empezar Lección",

    lessons_title: "Lecciones Interactivas",
    lessons_subtitle: "Lecciones IA estilo Khan para tu examen",
    lessons_remaining: "lecciones restantes",
    lessons_unlimited: "Lecciones ilimitadas",
    lessons_free_limit: "Plan gratis: 3 lecciones en total",
    lessons_upgrade: "Hazte Premium para lecciones ilimitadas",
    lesson_summary: "Puntos Clave",
    lesson_practice: "Práctica",
    lesson_continue: "Continuar a la práctica",
    lesson_complete: "Completar lección",
    lesson_new: "Empezar una nueva lección",
    pick_topic: "Elige un tema",

    onboarding_welcome: "¡Bienvenido a ClearPath!",
    onboarding_step1: "1. Elige tu examen",
    onboarding_step1_body: "Elige entre STAAR, SAT, ACT, ASVAB, TSI o Ciudadanía.",
    onboarding_step2: "2. Responde preguntas",
    onboarding_step2_body: "Gana XP por cada respuesta correcta.",
    onboarding_step3: "3. Lee las explicaciones",
    onboarding_step3_body: "Cada respuesta viene con una explicación clara.",
    onboarding_step4: "4. Habla con Archie",
    onboarding_step4_body: "Tu tutor IA — pregúntale cualquier cosa.",
    onboarding_step5: "5. Sigue tu progreso",
    onboarding_step5_body: "Mira tu puntuación de preparación subir.",
    onboarding_skip: "Saltar",
    onboarding_next: "Siguiente",
    onboarding_finish: "¡Vamos!",

    settings_title: "Configuración",
    settings_accessibility: "Accesibilidad",
    settings_dyslexia: "Modo amigable para dislexia",
    settings_dyslexia_desc: "Texto más grande, fondo crema, párrafos cortos y lectura en voz alta.",
    settings_language: "Idioma",
    settings_language_desc: "Traduce la interfaz. Las preguntas permanecen en inglés.",
    settings_replay_tour: "Repetir el tour de bienvenida",

    paywall_title: "¡No pares ahora!",
    paywall_message: "Has usado las 10 preguntas gratis de hoy. Tu examen STAAR se acerca — no pares ahora. Hazte Premium para práctica ilimitada.",
    upgrade_button: "Hazte Premium",
  },
};
